import {
  IFolder,
  IFolderV3,
  IPromissoryNotes,
} from '@literax/models/promissory-notes.model';

import { EOperatorFilterField } from '@literax/enums/query-parameters.enum';
import { ISignRequest } from '@literax/modules/documents/store/document/document.state';
import { IAppState } from '@literax/store/index';
import { createSelector } from '@ngrx/store';
import { IPromissoryNotesState } from './promissory-notes.state';

const selectPromissoryNotes = (state: IAppState) => state.promissoryNotes;

//#region Selects usados con la V2 de endpoints
//? Aun se utilizan en algún component de promissory note no migrado
export const selectConfigData = createSelector(
  selectPromissoryNotes,
  (state: IPromissoryNotesState) => state && state.configData
);

export const selectPromissoryConfigData = createSelector(
  selectConfigData,
  (state: IPromissoryNotes) => state && state.configData
);

export const selectParameters = createSelector(
  selectConfigData,
  (state: IPromissoryNotes) => state && state.params
);

export const selectDefaultData = createSelector(
  selectConfigData,
  (state: IPromissoryNotes) => state && state.defaultData
);

export const selectPromissoryNote = createSelector(
  selectPromissoryNotes,
  (state: IPromissoryNotesState) => state && state.selectPromissoryNote
);

export const selectPromissoryNoteV3 = createSelector(
  selectPromissoryNotes,
  (state: IPromissoryNotesState) => state && state.selectPromissoryNoteV3
);

export const selectPromissoryNoteActions = createSelector(
  selectPromissoryNotes,
  (state: IPromissoryNotesState) => state?.selectPromissoryNote?.actions
);

export const selectPromissoryNoteActionsV3 = createSelector(
  selectPromissoryNotes,
  (state: IPromissoryNotesState) => state?.selectPromissoryNoteV3?.actions
);

export const selectDocumentMain = createSelector(
  selectPromissoryNote,
  (state: IFolder) => state && state.main_document
);

export const selectDocuments = createSelector(
  selectPromissoryNote,
  (state: IFolder) => state && state.documents
);

export const selectDocumentMainV3 = createSelector(
  selectPromissoryNoteV3,
  (state: IFolderV3) => state && state.mainDocument
);

export const selectDocumentsV3 = createSelector(
  selectPromissoryNoteV3,
  (state: IFolderV3) => state && state.documents
);

export const selectAllDocumentsSingRequest = createSelector(
  selectPromissoryNote,
  (state: IFolder) => {
    const legalRepresentatives = [];

    let arraySigner: ISignRequest[] = [];
    if (state.main_document && state.main_document.user_signer === null) {
      arraySigner = arraySigner.concat(state.main_document.sign_requests || []);
    } else {
      state.documents.forEach((document) => {
        document.legal_representative?.forEach((representative) => {
          representative.legal_representatives.forEach(
            (legalRepresentative) => {
              legalRepresentatives.push(legalRepresentative);
            }
          );
        });
      });
      state.main_document.legal_representative?.forEach((representatives) => {
        representatives.legal_representatives.forEach((representative) => {
          legalRepresentatives.push(representative);
        });
      });
      const arraySignerUserMain = [
        ...legalRepresentatives,
        ...state.main_document.sign_requests,
      ];
      arraySigner = arraySigner.concat(arraySignerUserMain);
    }
    if (state.documents) {
      state.documents.forEach((document) => {
        if (document.user_signer === null) {
          arraySigner = arraySigner.concat(document.sign_requests || []);
        } else {
          const arraySignerDocuments = [...document.sign_requests];
          arraySigner = arraySigner.concat(arraySignerDocuments);
        }
      });
    }
    return arraySigner;
  }
);

export const selectAllDocumentsSingRequestV3 = createSelector(
  selectPromissoryNoteV3,
  (state: IFolderV3) => {

    const arraySigner: ISignRequest[] = [];

    if (state.mainDocument && state.mainDocument.signRequests) {
      state.mainDocument.signRequests.naturalPersons.forEach((signRequest) => {
        arraySigner.push({
          
          can_send_notification: signRequest.sendNotificationEmail,
          approval_required: signRequest.approvalRequired,
          id: signRequest.id,
          approved: signRequest.approvedAt > 0,
          color: signRequest.color,
          created_at: signRequest.createdAt
            ? new Date(signRequest.createdAt)
            : null,
          document_id: state.mainDocument.id,
          email: signRequest.email,
          expiry: signRequest.expiryAt ? new Date(signRequest.expiryAt) : null,
          id_document_request: signRequest.idDocumentRequest.toString(),
          is_author: signRequest.isAuthor,
          name: signRequest.name,
          order: signRequest.order,
          rfc: signRequest.taxId,
          role: signRequest.signatureRole?.signatoryRoleName,
          status: signRequest.status,
          user_terms_accepted: signRequest.acceptedUserTerms,
          last_email_event: {
            id: null,
            email: signRequest.email,
            smtp_id: signRequest.lastEmailEvent?.smtpId,
            created_at: new Date(
              signRequest.lastEmailEvent.createdAt
            ).toDateString(),
            status: signRequest.lastEmailEventName,
            updated_at: undefined,
            history: [],
          },
          sign_request_signature_quotes:[{
            signature_quote_text: signRequest.quote?.signatureQuoteText,
            record_uid: signRequest.quote?.formBuilderRecordUid,
            template_uid: signRequest.quote?.formBuilderTemplateId,
          }],
          is_delegate: signRequest.hasDelegated,
          delegate: null,
          signature_positions: signRequest.signaturePositions.map((sp) => ({
            page: sp.pageNumber,
            attachment_id: sp.attachmentId,
            x: sp.positionX,
            y: sp.positionY,
          })),
          signatory_role: {id: signRequest.signatureRole?.signatoryRoleId, name: signRequest.signatureRole?.signatoryRoleName},
        });
      });

       state.mainDocument.signRequests.legalPersons.forEach((signRequest) => {
        arraySigner.push({
          approval_required: signRequest.approvalRequired,
          id: signRequest.id,
          approved: false,
          color: signRequest.color,
          created_at: signRequest.createdAt
            ? new Date(signRequest.createdAt)
            : null,
          document_id: state.mainDocument.id,
          email: signRequest.email,
          expiry: signRequest.expiryAt ? new Date(signRequest.expiryAt) : null,
          id_document_request: signRequest.idDocumentRequest.toString(),
          is_author: signRequest.isAuthor,
          name: signRequest.name,
          order: signRequest.order,
          rfc: signRequest.taxId,
          role: signRequest.signatureRole?.signatoryRoleName,
          status: signRequest.status,
          user_terms_accepted: signRequest.acceptedUserTerms,
          last_email_event: {
            id: null,
            email: signRequest.email,
            smtp_id: signRequest.lastEmailEvent?.smtpId,
            created_at: new Date(
              signRequest.lastEmailEvent.createdAt
            ).toDateString(),
            status: signRequest.lastEmailEventName,
            updated_at: undefined,
            history: [],
          },
          sign_request_signature_quotes:[{
            signature_quote_text: signRequest.quote?.signatureQuoteText,
            record_uid: signRequest.quote?.formBuilderRecordUid,
            template_uid: signRequest.quote?.formBuilderTemplateId,
          }],
          is_delegate: false,
          delegate: null,
          signature_positions: null,
          signatory_role: {id: signRequest.signatureRole?.signatoryRoleId, name: signRequest.signatureRole?.signatoryRoleName},
          company_name: signRequest.companyName,
          company_rfc: signRequest.companyTaxId,
          can_send_notification: signRequest.sendNotificationEmail,
        });
      });
      console.log("sdsd", arraySigner);
      return arraySigner;
    }

    // if (state.main_document && state.main_document.user_signer === null) {
    //   arraySigner = arraySigner.concat(state.main_document.sign_requests || []);
    // } else {
    //   state.documents.forEach((document) => {
    //     document.legal_representative?.forEach((representative) => {
    //       representative.legal_representatives.forEach(
    //         (legalRepresentative) => {
    //           legalRepresentatives.push(legalRepresentative);
    //         }
    //       );
    //     });
    //   });
    //   state.main_document.legal_representative?.forEach((representatives) => {
    //     representatives.legal_representatives.forEach((representative) => {
    //       legalRepresentatives.push(representative);
    //     });
    //   });
    //   const arraySignerUserMain = [
    //     ...legalRepresentatives,
    //     ...state.main_document.sign_requests
    //   ];
    //   arraySigner = arraySigner.concat(arraySignerUserMain);
    // }
    // if (state.documents) {
    //   state.documents.forEach((document) => {
    //     if (document.user_signer === null) {
    //       arraySigner = arraySigner.concat(document.sign_requests || []);
    //     } else {
    //       const arraySignerDocuments = [...document.sign_requests];
    //       arraySigner = arraySigner.concat(arraySignerDocuments);
    //     }
    //   });
    // }
    return arraySigner;
  }
);

export const selectPaginationData = createSelector(
  selectPromissoryNotes,
  (state: IPromissoryNotesState) => state.pagination
);

export const getBeneficiary = createSelector(
  selectPromissoryNote,
  (state: IFolder) => state && state?.holder && state.holder.client
);

export const getBeneficiaryV3 = createSelector(
  selectPromissoryNoteV3,
  (state: IFolderV3) => state && state?.holder && state.holder.client
);

export const getCurrency = createSelector(
  selectPromissoryNotes,
  (state: IPromissoryNotesState) => state && state.currencys
);

export const getPayments = createSelector(
  selectPromissoryNotes,
  (state: IPromissoryNotesState) => {
    if (state && state?.payments) {
      const arrayPayments = state.payments
        .filter((item) => item.document_id === null)
        .map((item) => {
          return {
            value: item.id,
            label:
              item.payment_date +
              ' | ' +
              new Intl.NumberFormat('en-IN', {
                style: 'currency',
                currency: 'MXN',
              }).format(item.capital_amount),
          };
        });
      const notPayment = {
        value: 0,
        label: 'WORKSPACE_PROMISSORY.ACCEPT_PAYMENT.FORM.NOT_PAYMENT',
      };
      arrayPayments.push(notPayment);
      return arrayPayments;
    }
  }
);

export const getPromissoryNoteTemplate = createSelector(
  selectPromissoryNotes,
  (state: IPromissoryNotesState) => state.promissoryNoteTemplates
);

export const getPromissoryNoteTemplateSelect = createSelector(
  selectPromissoryNotes,
  (state: IPromissoryNotesState) => state.promissoryNoteTemplateSelect
);

export const getSelectPayment$ = createSelector(
  selectPromissoryNotes,
  (state: IPromissoryNotesState) => state && state.selectPayment
);

export const getPromissoryNoteWithTemplateSelect = createSelector(
  selectPromissoryNotes,
  (state: IPromissoryNotesState) => state.promissoryNoteWithData
);

export const getTemplateId = createSelector(
  selectPromissoryNotes,
  (state: IPromissoryNotesState) => state.templateId
);
//#endregion

//* Pagaré V3
export const getpromissoryNoteStatusCounters = createSelector(
  selectPromissoryNotes,
  (state: IPromissoryNotesState) => state.promissoryNoteStatusCounters
);

export const getPromissoryNoteList = createSelector(
  selectPromissoryNotes,
  (state: IPromissoryNotesState) => state.promissoryNoteList
);

export const GetPromissoryNoteStatusKey = createSelector(
  selectPromissoryNotes,
  (state: IPromissoryNotesState) => state.promissoryNoteAccumulatedStatusKey
);

export const getSearchedTextTerm = createSelector(
  selectPromissoryNotes,
  (state: IPromissoryNotesState) => {
    const filterFields = state.queryParameters?.filterFields ?? [];
    return (
      filterFields.find((f) => f.operator === EOperatorFilterField.ILI)?.term ??
      ''
    );
  }
);